<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            max-width="370"
        >
            <v-card>
                <v-card-title class="headline">
                    {{ deleteForm.header }}
                </v-card-title>

                <v-card-text>
                    {{ deleteForm.content }}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="primary"
                        outlined
                        @click="dialog = false"
                    >
                        {{ $vuetify.lang.t('$vuetify.deleteModal.cancel') }}
                    </v-btn>

                    <v-btn
                        color="primary"
                        @click="deleteSubmit()"
                    >
                        {{ $vuetify.lang.t('$vuetify.deleteModal.delete') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    name: 'deleteModal',

    props: {
        deleteForm: {
            type: Object,
            default: null
        }
    },

    data () {
        return {
            dialog: false
        }
    },
    methods: {
        async deleteSubmit () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.delete(this.deleteForm.path)
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success-deleted')
                this.dialog = false
                this.$store.dispatch('setLoading', false)
            } else if (res && res.data && res.data.status === 'error') {
                const errors = res.data.errors
                for (const property in errors) {
                    this.$notify({
                        title: this.$vuetify.lang.t('$vuetify.companyProfile.errorMessage'),
                        text: errors[property],
                        type: 'error'
                    })
                }
                this.dialog = false
                this.$store.dispatch('setLoading', false)
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
